module.exports = __webpack_public_path__ + "img/t1-6.bfeb6492.png";